import { useQuery } from '@tanstack/react-query';
import { timesheetService } from '@/services/timesheets/timesheetService';
import { timesheetQueryKeys } from './queryKeys';
import { useAuth } from '@/hooks/useAuth';

export const useMyTimeEntries = (month?: Date) => {
  const { profile } = useAuth();

  return useQuery({
    queryKey: timesheetQueryKeys.myTimeEntries(profile?.id || '', month),
    queryFn: () => timesheetService.getMyTimeEntries(profile?.id || '', month),
    enabled: !!profile?.id,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
